import { Injectable, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { EnvironmentService } from '@core/services/environment.service';
import { LoginRedirectService } from '@core/services/login-redirect.service';
import { UserService } from '@features/user/services/user.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IsNotAuthenticatedGuard implements CanActivate {
    private userService = inject(UserService);
    private loginRedirectService = inject(LoginRedirectService);
    private environmentService = inject(EnvironmentService);

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // Shell prerendering: auth resolves in the browser only.
        if (this.environmentService.isServer()) {
            return true;
        }
        return this.userService
            .isAuthenticated()
            .pipe(
                map((isAuthenticated: boolean) =>
                    isAuthenticated
                        ? this.loginRedirectService.retrieve(state.root)
                        : true
                )
            );
    }
}
